import querystring from 'querystring';
import api from 'services/api';

class LessonQuestionsData {
  getlessonQuestions(id_user, lesson_content_id, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.get(
      `lesson-content-exams/${id_user}/${lesson_content_id}${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }
  updateLessonQuestions(id_user, lesson_content_id, lessons) {
    return api.put(
      `/lesson-content-exams/${id_user}/${lesson_content_id}`,
      lessons
    );
  }

  sendExamResult(
    id_user,
    lesson_content_id,
    lesson_content_exams,
    availableExamAttempts,
    id_enrollment = null
  ) {
    return api.post(
      `/lesson-content-exams/student/${id_user}/finish/${lesson_content_id}`,
      {
        available_exam_attempts: availableExamAttempts,
        lesson_content_exams,
        id_enrollment,
      }
    );
  }

  saveExamProgress(
    id_user,
    lesson_content_id,
    lesson_content_exams,
    id_enrollment = null
  ) {
    return api.put(
      `/lesson-content-exams/student/${id_user}/progress/${lesson_content_id}`,
      { lesson_content_exams, id_enrollment }
    );
  }

  checkApprovedExam(id_lesson_content, id_user, id_course, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.get(
      `/check-is-approved/course/${id_course}/lesson-content/${id_lesson_content}/user/${id_user}${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }

  getExamResult(id_user, lesson_content_id, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.get(
      `/lesson-content-exams/student/${id_user}/result/${lesson_content_id}${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }

  getExamDetails(id_user, lesson_content_id, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.get(
      `/lesson-content-exams/student/${id_user}/exam-details/${lesson_content_id}${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }

  getExamDetailsAdmin(id, id_course, query = {}) {
    const queryParams = querystring.stringify(query);
    return api.get(
      `/lesson-content-exams/student/${id}/exam-details-admin/${id_course}${
        queryParams ? `?${queryParams}` : ''
      }`
    );
  }

  getPendingClasses(id_user, id_course, lesson_id = '') {
    return api.get(`lesson-content-exams-class-pending/student/${id_user}/course/${id_course}`, { params: { lesson_id } });
  }

  getWorkloadExam(id_user, id_course) {
    return api.get(`lesson-content-exams/student/${id_user}/workload-exam/${id_course}`);
  }
}

export default new LessonQuestionsData();
